import Encoding from 'encoding-japanese'
export default {
  methods: {
    /**
     * CSV をダウンロードする
     *
     * @param {*} csvList CSVのリスト
     * @param {*} prefix ファイルの先頭
     * @param {*} idParams ファイル名の中につけるIDのリスト(例：'${prefix}_${idParams...}_yyyyMMddhhmmss.csv')
     */
    csvDownload: function (csvList, prefix, idParams) {
      const d = new Date()
      const fd =
        `${d.getFullYear()}` +
        `${('0' + (d.getMonth() + 1)).slice(-2)}` +
        `${('0' + d.getDate()).slice(-2)}` +
        `${('0' + d.getHours()).slice(-2)}` +
        `${('0' + d.getMinutes()).slice(-2)}`

      let csvData = csvList.join('\r\n')
      const unicodeList = []
      for (let i = 0; i < csvData.length; i += 1) {
        unicodeList.push(csvData.charCodeAt(i))
      }
      const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode')
      const uInt8List = new Uint8Array(shiftJisCodeList)
      let blob = new Blob([uInt8List], { type: 'text/csv' })
      const filename = `${prefix}_${idParams.join('_')}_${fd}.csv`

      if (window.navigator.msSaveBlob) {
        // IE11向けのCSVDownload
        window.navigator.msSaveBlob(blob, filename)
        window.navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        // chrome、Firefox用のDownload
        let link = document.createElement('a')
        link.setAttribute('type', 'hidden')
        link.download = filename
        link.href = window.URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click()
        link.remove()
      }
    }
  }
}
